module.exports = __webpack_public_path__ + "img/-LV4zsu9U6yas3vOVCLp.d7ffe14e.jpg";